import { render, staticRenderFns } from "./AuthContainer.vue?vue&type=template&id=27ad9e3c&scoped=true"
import script from "./AuthContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthContainer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AuthContainer.vue?vue&type=style&index=0&id=27ad9e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad9e3c",
  null
  
)

export default component.exports